import { get as getFace } from '@/api/gabed/face';
import { get as getMateriel } from '@/api/gabed/materiel';
import { get as getDispositif } from '@/api/gabed/dispositif';
import { get as getEmplacement } from '@/api/gabed/emplacement';
import { get as getClient } from '@/api/tiers';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import cloneDeep from 'lodash/cloneDeep';

export async function getInfoPat(otPatrimoine) {
  let face = null;
  let materiel = null;
  let dispositif = null;
  let emplacement = null;
  if (otPatrimoine.faceId) {
    face = (await getFace(otPatrimoine.faceId)).data.result;
    materiel = face.materiel;
    dispositif = face.materiel.dispositif;
    emplacement = face.materiel.dispositif.emplacement;
  } else if (otPatrimoine.materielId) {
    materiel = (await getMateriel(otPatrimoine.materielId)).data.result;
    dispositif = materiel.dispositif;
    emplacement = materiel.dispositif.emplacement;
  } else if (otPatrimoine.dispositifId) {
    dispositif = (await getDispositif(otPatrimoine.dispositifId)).data.result;
    emplacement = dispositif.emplacement;
    if (emplacement.clientId) {
      emplacement.client = (await getClient(emplacement.clientId)).data.result;
    }
  } else if (otPatrimoine.emplacementId) {
    emplacement = (await getEmplacement(otPatrimoine.emplacementId)).data.result;
  }
  if (dispositif) {
    otPatrimoine.nomenclature = dispositif.nomenclature;
    otPatrimoine.nomenclatureTypeId = dispositif.nomenclatureTypeId;
  }
  return {
    face: face,
    materiel: materiel,
    dispositif: dispositif,
    emplacement: emplacement,
  };
}

function fillEmplacement(infoEmplacement, otPatrimoine, fillOnlyInfoNonEditable) {
  if (!infoEmplacement) return;
  otPatrimoine.emplacement = {
    code: infoEmplacement.code,
    id: infoEmplacement.id,
    adresse: adressFullStringGetter(infoEmplacement.adresseCadastrale),
    client: infoEmplacement.client,
  };
  if (fillOnlyInfoNonEditable) return;
  otPatrimoine.emplacementTechnique = {
    acces: infoEmplacement.emplacementTechnique.acces,
    accesSiteSurRdv: infoEmplacement.emplacementTechnique.accesSiteSurRdv,
    codeBarre: infoEmplacement.emplacementTechnique.codeBarre,
    degreDeniveleTerrain: infoEmplacement.emplacementTechnique.degreDeniveleTerrain,
    natureSol: infoEmplacement.emplacementTechnique.natureSol,
    groupeDhabitation: infoEmplacement.emplacementTechnique.groupeDhabitation,
    numUG: infoEmplacement.emplacementTechnique.numUG,
    quartier: infoEmplacement.emplacementTechnique.quartier,
  };
}

function fillDispositif(infoDispositif, otPatrimoine, fillOnlyInfoNonEditable) {
  if (!infoDispositif) return;
  otPatrimoine.dispositif = {
    id: infoDispositif.id,
    code: infoDispositif.code,
    dispositifTypeId: infoDispositif.dispositifTypeId,
    dispositifSupportId: infoDispositif.dispositifSupportId,
    etat: infoDispositif.etat,
    adresse: adressFullStringGetter(infoDispositif.adresse),
  };
  if (fillOnlyInfoNonEditable) return;
  otPatrimoine.dispositifTechnique = {
    autreEquipementNecessaire: infoDispositif.dispositifTechnique.autreEquipementNecessaire,
    cableEdfProx: infoDispositif.dispositifTechnique.cableEdfProx,
    couleurRAL: infoDispositif.dispositifTechnique.couleurRAL,
    declarationPrealable: infoDispositif.dispositifTechnique.declarationPrealable,
    distanceEnMCablesEdf: infoDispositif.dispositifTechnique.distanceEnMCablesEdf,
    echelleNecessaire: infoDispositif.dispositifTechnique.echelleNecessaire,
    eclairable: infoDispositif.dispositifTechnique.eclairable,
    fournisseurElectricite: infoDispositif.dispositifTechnique.fournisseurElectricite,
    fournisseurElectriciteId: infoDispositif.dispositifTechnique.fournisseurElectriciteId,
    grueNecessaire: infoDispositif.dispositifTechnique.grueNecessaire,
    hauteurSousPanneau: infoDispositif.dispositifTechnique.hauteurSousPanneau,
    largeurToit: infoDispositif.dispositifTechnique.largeurToit,
    longueur: infoDispositif.dispositifTechnique.longueur,
    nacelleNecessaire: infoDispositif.dispositifTechnique.nacelleNecessaire,
    obstacle: infoDispositif.dispositifTechnique.obstacle,
    particularite: infoDispositif.dispositifTechnique.particularite,
    planRecollement: infoDispositif.dispositifTechnique.planRecollement,
    publicitaire: infoDispositif.dispositifTechnique.publicitaire,
    restrictionsAffichage: infoDispositif.dispositifTechnique.restrictionsAffichage,
    tiersProprietaire: infoDispositif.dispositifTechnique.tiersProprietaire,
    tiersProprietaireId: infoDispositif.dispositifTechnique.tiersProprietaireId,
    valeurAcquisition: infoDispositif.dispositifTechnique.valeurAcquisition,
  };
}

function fillMateriel(infoMateriel, otPatrimoine, fillOnlyInfoNonEditable) {
  if (!infoMateriel) return;
  otPatrimoine.materiel = {
    id: infoMateriel.id,
    code: infoMateriel.code,
    typeId: infoMateriel.typeId,
    formatId: infoMateriel.formatId,
  };
  if (fillOnlyInfoNonEditable) return;
  otPatrimoine.materielTechnique = {
    passerelle: infoMateriel.materielTechnique.passerelle,
    typeEclairage: infoMateriel.materielTechnique.typeEclairage,
    longueur: infoMateriel.materielTechnique.longueur,
    largeur: infoMateriel.materielTechnique.largeur,
  };
}

function fillFace(infoFace, otPatrimoine) {
  if (!infoFace) return;
  otPatrimoine.face = {
    id: infoFace.id,
    code: infoFace.code,
  };
}
function fillAccessoire(infoDispositif, otPatrimoine) {
  if (!infoDispositif || !infoDispositif.dispositifAccessoires) return;
  otPatrimoine.otPatrimoineAccessoires = cloneDeep(infoDispositif.dispositifAccessoires);
  otPatrimoine.otPatrimoineAccessoires.forEach((accessoire) => {
    delete accessoire.id;
  });
}

export async function fillInfoOtPatrimoine(otPatrimoine, fillOnlyInfoNonEditable) {
  if (!otPatrimoine) return;
  const info = await getInfoPat(otPatrimoine);
  fillEmplacement(info.emplacement, otPatrimoine, fillOnlyInfoNonEditable);
  fillDispositif(info.dispositif, otPatrimoine, fillOnlyInfoNonEditable);
  fillMateriel(info.materiel, otPatrimoine, fillOnlyInfoNonEditable);
  fillFace(info.face, otPatrimoine);
  if (!fillOnlyInfoNonEditable) {
    fillAccessoire(info.dispositif, otPatrimoine, fillOnlyInfoNonEditable);
  }
}
